import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import SplitForm from "../SplitForm";

const STRIPE_PK = process.env.REACT_APP_STRIPE_PUBLISHER_KEY;
const SubscriptionForm = () => {
  const [pk, setPk] = useState();
  const [stripePromise, setStripePromise] = useState(null);
  useEffect(() => {
    setTimeout(() => {
      setPk(STRIPE_PK);
    }, 1500);
  }, []);

  useEffect(() => {
    if (pk && !stripePromise) {
      setStripePromise(loadStripe(pk));
    }
  }, [pk, stripePromise]);
  return (
    <Elements stripe={stripePromise}>
      <SplitForm />
    </Elements>
  );
};

export default SubscriptionForm;
